import scrollLock from "@/helpers/scroll-lock";
import { scrollIntoViewWithOffset } from "@/helpers/scroll.js";

const state = {
  selectedSection: null,
  isMenuOpen: false,
};

const getters = {};

const mutations = {
  setSelectedSection(state, value) {
    state.selectedSection = value;
  },
  toggleMenuState(state) {
    state.isMenuOpen = !state.isMenuOpen;
  },
};

const actions = {
  updateSelectedSection({ commit, dispatch }, { section, navigate = false }) {
    commit("setSelectedSection", section);

    const url = new URL(window.location);
    const oldSection = url.searchParams.get("section");

    if (oldSection !== section) {
      url.searchParams.set("section", section);
      window.history.pushState(null, "", url.toString());
    }

    if (navigate) {
      dispatch("scrollToSection");
    }
  },
  scrollToSection({ state }) {
    const itemElement = document.getElementById(state.selectedSection);

    if (!itemElement) {
      return;
    }

    scrollIntoViewWithOffset(itemElement, 60);
  },
  toggleMenu({ commit, state }) {
    commit("toggleMenuState");
    state.isMenuOpen ? scrollLock.enable() : scrollLock.disable();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
